export default __webpack_public_path__ + "static/media/370.4435da82.png";